module.exports = __webpack_public_path__ + "img/charter-3.3e645d1.webp";